document.addEventListener('DOMContentLoaded', function () {
  let nextPageUrl = document.querySelector('#next-page') ? document.querySelector('#next-page').getAttribute('href') : null;
  let isLoading = false;
  let loadingSpinner = document.getElementById('loading-spinner');

  window.addEventListener('scroll', function () {
    if (!nextPageUrl || isLoading) return;

    let scrollPosition = window.innerHeight + window.scrollY;
    let documentHeight = document.body.offsetHeight;

    // Quando o usuário rolar até 100px do final da página
    if (scrollPosition >= documentHeight - 100) {
      isLoading = true;
      
      // Mostra o spinner
      if (loadingSpinner) {
        loadingSpinner.style.display = 'block';
      }

      fetch(nextPageUrl)
        .then(response => response.text())
        .then(data => {
          let parser = new DOMParser();
          let doc = parser.parseFromString(data, 'text/html');
          let newProducts = doc.querySelectorAll('#product-grid > *');
          let productContainer = document.querySelector('#product-grid');
          newProducts.forEach(product => productContainer.appendChild(product));

          // Atualiza o próximo link da página
          let newNextPage = doc.querySelector('#next-page');
          nextPageUrl = newNextPage ? newNextPage.getAttribute('href') : null;

          // Esconde o spinner
          if (loadingSpinner) {
            loadingSpinner.style.display = 'none';
          }

          isLoading = false;
        })
        .catch(() => {
          // Esconde o spinner em caso de erro também
          if (loadingSpinner) {
            loadingSpinner.style.display = 'none';
          }
          isLoading = false;
        });
    }
  });
});
